import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
export function ProofSection() {
  return <section className="bg-[#17304F] text-white py-24 px-6" data-id="element-232">
      <div className="max-w-3xl mx-auto text-center" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-slate-800/50 border border-slate-700 p-8 md:p-12 rounded-2xl relative" data-id="element-234">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-amber-600 text-white p-3 rounded-full shadow-lg" data-id="element-235">
            <Clock size={28} data-id="element-236" />
          </div>

          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-offwhite mb-8 mt-4" data-id="element-237">
            Lo que cambia en 7 días
          </h2>

          <div className="text-lg md:text-xl text-slate-300 leading-relaxed space-y-6 font-medium" data-id="element-238">
            <p data-id="element-239">
              Al aplicar estos protocolos, lo primero que vas a notar es que{' '}
              <strong className="text-white" data-id="element-240">
                el silencio vuelve a tu casa
              </strong>
              . Tu ex, al no encontrar la reacción que lo alimenta, empieza a
              buscar otra vía o simplemente se rinde.
            </p>
            <p data-id="element-241">
              Pero lo más importante sucede en tu interior:{' '}
              <strong className="text-amber-400" data-id="element-242">
                la taquicardia desaparece
              </strong>
              . Volvés a ser dueño de tu tiempo y tus hijos recuperan a un
              padre/madre que está realmente ahí, con la cabeza en el presente.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}